import React from 'react';
import ContentModelHandler from '../../utils/ContentModelHandler';

interface ContainerInterface {
  data: {
    containerType: string;
    content: Array<object>;
    extraClasses?: string;
  };
}

function Container({ data }: ContainerInterface) {
  const { containerType, content, extraClasses } = data;

  const containerTypeHandler = (type: string) => {
    switch (type) {
      case 'Trial Info Container':
        return 'cl-trial-info--container';
      case 'Case Study Container':
        return 'cl-case-study--details-container';
      case 'FAQ Container':
        return 'cl-faq-container';
      case 'FAQ Numbered Container':
        return 'cl-faq-container cl-faq-container--numbered';

      default:
        return '';
    }
  };

  return (
    <div
      className={`cl-content-container ${containerTypeHandler(containerType)} ${
        extraClasses ? extraClasses : ''
      }`}
    >
      {content.map((item) => ContentModelHandler([item]))}
    </div>
  );
}

export default Container;
